<template>
    <modal id="product-modal"
           v-model="showModal"
           :title="generateModalTitle('product')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader"
    >
        <form method="post"
              @submit.prevent="submitData"
              ref="form"
              :data-url="selectedUrl ? selectedUrl : apiUrl.PRODUCTS"
        >
            <app-form-group
                    :label="$t('name')"
                    v-model="formData.name"
                    :placeholder="$placeholder('product', 'name')"
                    :error-message="$errorMessage(errors, 'name')"
            />

            <app-form-group-selectable
                    type="multi-select"
                    :label="$t('categories')"
                    v-model="formData.categories"
                    choose-label="categories"
                    :fetch-url="apiUrl.SELECTABLE_CATEGORIES"
                    :error-message="$errorMessage(errors, 'categories')"
                    list-value-field="name"
            />

            <app-form-group-selectable
                    :label="$t('brand')"
                    v-model="formData.brand_id"
                    choose-label="brand"
                    :fetch-url="apiUrl.SELECTABLE_BRANDS"
                    :error-message="$errorMessage(errors, 'brand_id')"
                    list-value-field="name"
            />

            <app-form-group
                    type="select"
                    :label="$t('unit_type')"
                    v-model="formData.unit_type"
                    :list="unitTypes"
                    :error-message="$errorMessage(errors, 'unit_type')"
            />

            <app-form-group
                    type="number"
                    :label="$t('unit')"
                    v-model="formData.unit"
                    :placeholder="$placeholder('product', 'unit')"
                    :error-message="$errorMessage(errors, 'unit')"
            />

            <app-form-group
                    type="number"
                    :label="$t('purchase_price')"
                    v-model="formData.purchase_price"
                    :placeholder="$placeholder('product', 'purchase_price')"
                    :error-message="$errorMessage(errors, 'purchase_price')"
            />

            <app-form-group
                    type="number"
                    :label="$t('sell_price')"
                    v-model="formData.sell_price"
                    :placeholder="$placeholder('product', 'sell_price')"
                    :error-message="$errorMessage(errors, 'sell_price')"
            />

            <app-form-group
                    type="number"
                    :label="$t('total_discount_amount')"
                    v-model="formData.total_discount_amount"
                    :placeholder="$placeholder('product', 'total_discount_amount')"
                    :error-message="$errorMessage(errors, 'total_discount_amount')"
            />

            <div class="form-group">
                <label for="image">{{ $t('image') }}</label>
                <app-input
                        :generate-file-url="false"
                        :label="$t('choose_file')"
                        type="custom-file-upload"
                        v-model="default_image"
                        id="image"
                />
            </div>
            <app-form-group
                    type="textarea"
                    :label="$t('description')"
                    v-model="formData.description"
                    :placeholder="$placeholder('product', 'description')"
                    :error-message="$errorMessage(errors, 'description')"
                    :text-area-rows="5"
            />
        </form>
    </modal>
</template>

<script>
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";
    import ModalMixin from "../../../Mixins/ModalMixin";
    import {productUnitTypes} from "../../../../common/productUnitTypes";
    import {addChooseInSelectArray, collection, formDataAssigner} from "../../../Helpers/Helpers";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "ProductCreateEdit",
        mixins: [FormHelperMixin, ModalMixin],
        data() {
            return {
                default_image: '',
            }
        },
        computed: {
            unitTypes() {
                return addChooseInSelectArray(
                    productUnitTypes(),
                    'value',
                    'unit_type',
                );
            }
        },
        methods: {
            submitData() {
                this.fieldStatus.isSubmit = true;
                this.loading = true;
                this.message = '';
                this.errors = {};
                const formData = formDataAssigner(new FormData, this.formData);
                if (this.formData.categories && this.formData.categories.length) {
                    formData.append('categories', this.formData.categories);
                }
                if (this.default_image) {
                    formData.append('default_image', this.default_image);
                }

                if (this.selectedUrl) {
                    formData.append('_method', 'patch');
                }

                this.submitFromFixin(
                    'post',
                    this.selectedUrl ? this.selectedUrl : this.apiUrl.PRODUCTS,
                    formData
                );
            },
            afterSuccess({data}) {
                this.formData = {};
                if (this.selectedUrl) {
                    $('#product-modal').modal('hide');
                    this.$emit('input', false);
                    this.toastAndReload(data.message, 'products-table');
                    this.$emit('success')
                    return;
                }
                this.toastAndReload(data.message);
                window.location = urlGenerator(`${this.apiUrl.PRODUCTS}/${data.product.slug}/edit`)
            },
            afterSuccessFromGetEditData({data}) {
                this.formData = data;
                this.preloader = false;
                this.default_image = data?.image?.path;
                this.formData.categories = collection(data.categories).pluck();
                this.formData.total_discount_amount = data.default_discount;
            }
        }
    }
</script>

<style scoped>

</style>